export default "__VITE_ASSET__D8Q4EBsw__"